import { render } from "./HeroiconsSolidInformationCircle.vue?vue&type=template&id=06768b9a"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidInformationCircle.vue"]])

export default __exports__